import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const BottomSheetImage: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiTitleURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  const multiSubButtonURL = getFontURL(btnFontFamily?.multi_sub_button);
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const multiButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  // const multiSubButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_sub_button}`;

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
    }

  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
    }

  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
    }

  @font-face {
    font-family: 'multiSubButton';
    src: url(${multiSubButtonURL});
    }   
    
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0,${displayValue});
    }

    .modal_wrapper {      
      width: 100%;
      height: 32rem;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
      background-color: transparent;
      z-index: 0
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      height: 15.5rem;
      outline: none;
    }   
    .slick_wrapper {
      position: absolute;
      top: 0;
      left: 0;      
    }
    .slick-track {
      display: flex;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
    }
    .slick-track img {
      object-fit: cover;
      
    }
    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      top: 1rem;
      right: 0.94rem;

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .contents_wrapper {
      margin-top: 15.5rem;
      height: 16.5rem;
      padding: 0 10%;

      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .contents_box {
      width: 100%;
      height: 8rem;
      padding: 1.5rem 0 0.5rem 0;
    }
    .contents_box .title {
      width: 100%;
      height: 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .btn_wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      position: relative;
    }
    .btn_wrapper button {
      height: 3rem;
      border: 0;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      color: ${btnColor?.multi_button};
      font-weight: ${btnFontWeight?.multi_button};
      font-size: ${btnFontSize?.multi_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiButton'
      };

      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      color: ${btnColor?.multi_sub_button};
      font-weight: ${btnFontWeight?.multi_sub_button};
      font-size: ${btnFontSize?.multi_sub_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_sub_button
        )
          ? btnFontFamily?.multi_sub_button
          : 'multiSubButton'
      };

      border-radius: ${radius?.multi_sub_button}px;
      background-color: rgba(${btnBgColorR?.multi_sub_button},${
    btnBgColorG?.multi_sub_button
  }, ${btnBgColorB?.multi_sub_button}, ${btnBgColorA?.multi_sub_button});
    }

    .test_image_1 {
      width: 100%;
      height: 15.5rem;

      position: absolute;
      top: 0;
      left: 0;
    }
    .test_image_2 {
      width: 100%;
      height: 8rem;
    }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        height: 52rem;
      }
      .contents_wrapper {
        margin-top: 29.0625rem;
        height: 22.94rem;
        padding: 0 25%;
      }

      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list,
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        height: 29.0625rem;
      }
      .contents_box {
        height: 10.5rem;
        padding: 2rem 0 1rem 0;
      }
      .contents_box .title {
        height: 3rem;
        margin-bottom: 0.5rem;
        font-size: ${fontSize?.multi_title + 0.75}rem;
      }
      .contents_box .sub_title {
        font-size: ${fontSize?.multi_sub_title + 0.25}rem;
        -webkit-line-clamp: 3;
      }

      .btn_wrapper {
        gap: 1rem;
      }
      .btn_wrapper button {
        height: 4rem;
      }
    }
  `;

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">
        ${bgImage?.multi_image
          ?.map(
            (data: any, idx: number) => `
          <div
            style={{ display: 'inline-block' }}
            data-btn-text="Shop now"
            data-btn-href="javascrupt:01;"
          >
            <img
              class="image"
             
              src="${bgImage?.multi_image[idx]}"
              alt="half top image"
            />
          </div>
      `
          )
          .join('')}
          </div>
          ${
            bgImage?.multi_image?.length !== 1
              ? `
          <div class="slick_page">
            <span class="slick_number"></span>
            <span class="slash">/</span>
            <span>${bgImage?.multi_image?.length}</span>
          </div>
          `
              : ''
          }
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">
          ${text?.multi_title
            ?.map(
              (_: any, idx: number) => `
          <div class="contents_box">
            <div class="title">${changeEnterHTML(
              text?.multi_title?.[idx]
            )}</div>
            <div class="sub_title">${changeEnterHTML(
              text?.multi_sub_title?.[idx]
            )}</div>
          </div>
        `
            )
            .join('')}
          </div>
          <div class="btn_wrapper">
            <button class="style01"></button>
            <button class="style02"></button>
          </div>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `"${deeplink?.multi_image?.[i]}",`;
  }
  deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `['${btnText?.multi_button?.[i]}', '${btnText?.multi_sub_button?.[i]}'],`;
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.multi_sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'BOTTOM SHEET IMAGE',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: false,
        infinite: true,
        dots: false,

        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        touchThreshold: 300
      });

      $('.contents_slider').slick({
        arrows: false,
        infinite: true,
        fade: true,
    
        speed: 300,
        swipe: false
      });

      let currentIndex = 0;
      let button = ${button_list};
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
      $('.slick_number').text(currentIndex+1);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.contents_slider').slick('goTo', currentIndex);
        $('.slick_number').text(currentIndex+1);
        $('.style01').text(button[currentIndex][0]);
        $('.style02').text(button[currentIndex][1]);
      });

      let deeplink = ${deeplink_list};
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.image').click(function() {
        appboyBridge.logClick(tracking[currentIndex][0]);
        try {
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.style01').click(function() {
        appboyBridge.logClick(tracking[currentIndex][1]);
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.style02').click(function() {
        appboyBridge.logClick(tracking[currentIndex][2]);
        try {
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default BottomSheetImage;
